import {
    Dialog,
    DialogContent,
    DialogHeader,
    DialogTitle,
    DialogDescription,
} from "./ui/dialog";
import { Button } from "./ui/button";

export default function ComingSoonModal({ brand, onClose }) {
    return (
        <Dialog open={Boolean(brand)} onOpenChange={(open) => !open && onClose()}>
            <DialogContent
                className="border-amber-400/20 bg-[#0A0B10]/95 text-slate-100 shadow-[0_0_80px_rgba(0,122,255,0.15),0_0_40px_rgba(212,175,55,0.12)] backdrop-blur-2xl sm:max-w-md"
                data-testid="teg-coming-soon-modal"
            >
                <div
                    className="pointer-events-none absolute inset-x-0 top-0 h-px"
                    style={{
                        background:
                            "linear-gradient(90deg, transparent, rgba(212,175,55,0.7), rgba(0,122,255,0.5), transparent)",
                    }}
                    aria-hidden="true"
                />
                <DialogHeader className="pt-2 text-center">
                    {brand?.logo && (
                        <img
                            src={brand.logo}
                            alt={`${brand.name} logo`}
                            className={
                                brand.logoShape === "wide"
                                    ? "mx-auto mb-4 h-16 w-auto max-w-[170px] rounded-lg object-contain"
                                    : "mx-auto mb-4 h-20 w-20 rounded-full object-cover ring-1 ring-amber-400/40"
                            }
                        />
                    )}
                    <p className="font-mono-lux mb-3 text-[10px] tracking-[0.4em] text-blue-300 uppercase">
                        Coming Soon
                    </p>
                    <DialogTitle className="font-display text-center text-2xl font-medium tracking-wide text-slate-100">
                        {brand?.name}
                    </DialogTitle>
                    <DialogDescription className="pt-3 text-center text-sm leading-relaxed text-slate-400">
                        This Truth Excellence Group brand is currently being developed. Please
                        check back for updates.
                    </DialogDescription>
                </DialogHeader>
                <div className="flex justify-center pt-2 pb-2">
                    <Button
                        type="button"
                        onClick={onClose}
                        data-testid="teg-coming-soon-close-btn"
                        className="min-h-[44px] rounded-full border border-amber-400/50 bg-transparent px-8 text-[11px] tracking-[0.25em] text-amber-300 uppercase transition-all duration-300 hover:bg-amber-400/10 hover:shadow-[0_0_24px_rgba(212,175,55,0.35)]"
                        variant="outline"
                    >
                        Close
                    </Button>
                </div>
            </DialogContent>
        </Dialog>
    );
}
